import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=0d77d4ae&scoped=true&"
import script from "./ModalHeader.vue?vue&type=script&lang=js&"
export * from "./ModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=0d77d4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d77d4ae",
  null
  
)

export default component.exports